let variant = {};
let payment = 'full';

const steps = document.querySelectorAll('.flow-step');

function go(step) {
  steps.forEach(s => s.classList.remove('is-active'));
  document.querySelector(`[data-step="${step}"]`).classList.add('is-active');
}
function formatPrice(value) {
  return Number.isInteger(value)
    ? '€' + value
    : '€' + value.toFixed(3);
}
const originalImageHTML = document.querySelector(".fox-flow__image").innerHTML;

document.querySelectorAll('.battery-card').forEach(card => {
  card.onclick = () => {
    document.querySelectorAll('.battery-card').forEach(c => c.classList.remove('active'));
    card.classList.add('active');

    variant = {
      id: card.dataset.variantId,
      title: card.dataset.variantTitle,
      price: parseFloat(card.dataset.price),
      image: card.dataset.image,
      direct: parseFloat(card.dataset.direct),
      directFormatted: card.dataset.directFormatted,

      total99: parseFloat(card.dataset.total99),
      total99Formatted: card.dataset.total99Formatted
    };

    document.getElementById('flow-image').src = variant.image;
    document.querySelector('[data-step="1"] .cta').disabled = false;
      
   

  };
});

document.querySelectorAll('.payment-row').forEach(row => {
  row.onclick = () => {
    document.querySelectorAll('.payment-row').forEach(r => r.classList.remove('active'));
    row.classList.add('active');
    payment = row.querySelector('input').value;
  };
});

document.querySelectorAll('.cta').forEach(btn => {
  btn.onclick = () => {


    const step = btn.closest('.flow-step')?.dataset.step;
    if (!step || step == 3) return;

    window.scrollTo(0, 0);
    if (step == 1) {
      document.getElementById('step2-price').textContent = variant.directFormatted;
      document.querySelector('.secondpartprice').textContent = variant.directFormatted; 
      document.querySelector('.totalprice').textContent = variant.total99Formatted;
      let option_small_ = document.querySelector('.option_small_');
      let variant_oprice = variant.oprice;
      let variant_totalprice = variant.totalprice;
      console.log('option_small_', option_small_);
      option_small_.innerHTML = `Betaal vandaag €99 als eerste betaling.
                                  Bij levering betaal je het resterende bedrag van ${variant.directFormatted}.
                                  De totale prijs bij deze betaaloptie is ${variant.total99Formatted}`

    }

    if (step == 2) {  
      
     const isReserve = payment === 'reserve';

      const now   = isReserve ? 99 : variant.price;         // pay today
      const later = isReserve ? variant.direct : 0;         // pay on delivery
      const total = isReserve ? variant.total99 : variant.price; // total shown

      document.getElementById('pay-today').innerText     = now.toFixed(3);
      document.getElementById('summary-now').innerText = formatPrice(now);
      document.getElementById('summary-later').innerText = formatPrice(later);
      document.getElementById('summary-total').innerText = formatPrice(total);

      document.getElementById('summary-image').src = variant.image;
      document.getElementById('final-variant').value = variant.id;
      document.querySelector(".lastproductprice").innerHTML = "Aantal: " + variant.title + '<span id="summary-qty">' + variant.oprice; +'</span>';
      document.querySelector(".flow-progress").style.display = "flex";
      document.querySelector(".fox-flow-title").style.display = "none";
      let newHTML;
      if((now.toFixed(3)) == 1.199){
        newHTML = '<div class="finalsummarytext">' +
                  '<h2>' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 48 48">' +
                      '<title>lock - close - solid</title>' +
                      '<g id="Layer_2" data-name="Layer 2">' +
                        '<g id="invisible_box" data-name="invisible box">' +
                          '<rect width="48" height="48" fill="none" />' +
                        '</g>' +
                        '<g id="icons_Q2" data-name="icons Q2">' +
                          '<path d="M40,18H36V13A11,11,0,0,0,25,2H23A11,11,0,0,0,12,13v5H8a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V20A2,2,0,0,0,40,18ZM25.9,33.4v2.5a2,2,0,0,1-4,0V33.4a4,4,0,1,1,4,0ZM32,18H16V13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7Z" />' +
                        '</g>' +
                      '</g>' +
                    '</svg> Afrekenen' +
                  '</h2>' +
                '</div>' +
                '<div class="finaltextblock">' +
                  '<b>Betaal vandaag </b>' + now.toFixed(3) + ' en bespaar <b>99</b>' +
                '</div>';

      }else if ((now.toFixed(3)) == 99.000){
        
        newHTML = '<div class="finalsummarytext">' +
                  '<h2>' +
                    '<svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 48 48">' +
                      '<title>lock - close - solid</title>' +
                      '<g id="Layer_2" data-name="Layer 2">' +
                        '<g id="invisible_box" data-name="invisible box">' +
                          '<rect width="48" height="48" fill="none" />' +
                        '</g>' +
                        '<g id="icons_Q2" data-name="icons Q2">' +
                          '<path d="M40,18H36V13A11,11,0,0,0,25,2H23A11,11,0,0,0,12,13v5H8a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V20A2,2,0,0,0,40,18ZM25.9,33.4v2.5a2,2,0,0,1-4,0V33.4a4,4,0,1,1,4,0ZM32,18H16V13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7Z" />' +
                        '</g>' +
                      '</g>' +
                    '</svg> Afrekenen' +
                  '</h2>' +
                '</div>' +
                '<div class="finaltextblock">' +
                  '<b>Betaal vandaag ' + now.toFixed(0) + '</b> en de rest bij levering' +
                '</div>';
      } else{
        newHTML = '<div class="finalsummarytext"><h2><svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 48 48">< title > lock - close - solid</><g id="Layer_2" data-name="Layer 2"><g id="invisible_box" data-name="invisible box"><rect width="48" height="48" fill="none" /></g><g id="icons_Q2" data-name="icons Q2"><path d="M40,18H36V13A11,11,0,0,0,25,2H23A11,11,0,0,0,12,13v5H8a2,2,0,0,0-2,2V44a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V20A2,2,0,0,0,40,18ZM25.9,33.4v2.5a2,2,0,0,1-4,0V33.4a4,4,0,1,1,4,0ZM32,18H16V13a7,7,0,0,1,7-7h2a7,7,0,0,1,7,7Z" /></g></g></svg > Afrekenen</h2 ></div > <div class="finaltextblock" ><b>Betaal vandaag ' + variant.price.toFixed(3) + '</b> en bespaar <b>' + now.toFixed(3) + ' </b></>';
      }

      document.querySelector(".fox-flow__image").innerHTML = newHTML;
    }
    const checkoutNote = document.querySelector('.checkout-box.last');

    if (payment === 'reserve') {
      checkoutNote.style.display = 'block';
    } else {
      checkoutNote.style.display = 'none';
    }
    go(parseInt(step) + 1);
  };
});


document.querySelector(".formaddtocart").addEventListener("click", function (e) {
  e.preventDefault()
  this.textContent = 'Even geduld a.u.b....';
  if (document.querySelector('[name="payment"]:checked').value == 'full') {
    document.querySelector(".pp-button-full-payment").click()
  } else {
    document.querySelector(".pp-button-part-payment").click()
  }

})

let variant_wrapper = document.querySelector('.battery-options');
variant_wrapper.addEventListener('click', function () {
  let final_variant__id = document.querySelector('.battery-card.active');
  
  if (final_variant__id) {
    let final_update_id = final_variant__id.dataset.variantId
    document.querySelector('.product-form-wrapper input[name="id"]').value = final_update_id;
    document.querySelector('.installment input[name="id"]').value = final_update_id;
    document.querySelector('.laststep input[name="id"]').value = final_update_id;
    const newUrl = window.location.pathname + '?variant=' + final_update_id;
    window.history.replaceState(null, null, newUrl);
  }
});

function go(step) {
  steps.forEach(s => s.classList.remove('is-active'));
  document.querySelector(`[data-step="${step}"]`).classList.add('is-active');

  const stepWrapper = document.querySelector('.step_wrapper');
if (step < 3) {
  document.querySelector(".fox-flow__image").innerHTML = originalImageHTML;
}
  if (step == 2 || step == 3) {
    stepWrapper.style.display = 'flex';
  } else {
    stepWrapper.style.display = 'none';
  }
}
document.querySelector('.step_wrapper').addEventListener('click', function () {
  const activeStep = document.querySelector('.flow-step.is-active');
  const currentStep = parseInt(activeStep.dataset.step);

  if (currentStep > 1) {
    go(currentStep - 1);
  }
});



